import { render, staticRenderFns } from "./IqosLogo.vue?vue&type=template&id=458b8ce6&"
import script from "./IqosLogo.vue?vue&type=script&lang=js&"
export * from "./IqosLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports